import React from 'react';
import PropTypes from 'prop-types';
import { TEXT_SIZE, TEXT_COLOR } from '@components/Text';
import { getFormattedTextCurry } from '@shared/Resources/Monitor/shared/utils/formattedText';
import CustomTextConfig from './components/CustomTextConfig';
import {
  CustomStimulusTitle,
  InputContainer,
} from './styles';

const getFormattedText = getFormattedTextCurry();

const CustomConfig = ({ config, updateField, updateConfig }) => (
  <React.Fragment>
    <CustomStimulusTitle>
      {getFormattedText('Stimuli.stimulusText', { textColor: TEXT_COLOR.DARK_BLUE, weight: 'bold' })}
      {getFormattedText('Informative.Notifying.productionNotChange', { size: TEXT_SIZE.T4, textColor: TEXT_COLOR.LIGHT_GRAY, margin: '0 0 -1px 0' })}
    </CustomStimulusTitle>
    <CustomTextConfig config={config} updateField={updateField} updateConfig={updateConfig} />
    <InputContainer>
    </InputContainer>
  </React.Fragment>
);

CustomConfig.propTypes = {
  config: PropTypes.object,
  updateField: PropTypes.func,
  updateConfig: PropTypes.func,
};

export default CustomConfig;

